import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-standart-tabs',
  templateUrl: './standart-tabs.component.html',
  styleUrls: ['./standart-tabs.component.css']
})
export class StandartTabsComponent implements OnInit {

  flag = true;
  constructor() { }

  ngOnInit() {
  }

  change(data) {
    this.flag = data;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standart-tabs/standart-tabs.component.ts